import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

const API_BROKER_TREES_BASE = "/admin/broker-trees";
const API_TRADING_ACCOUNTS_BASE = "/admin/trading-accounts";

export async function getBrokerTrees() {

  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    const res = await AxiosInstance.get(API_BROKER_TREES_BASE, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    });

    return res;
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

export async function getTradingAccountsByTreeId(idTree) {
  const normalizedIdTree = String(idTree ?? "").trim();

  if (!normalizedIdTree) {
    console.error("The id_tree parameter is required.");
    return null;
  }

  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    return await AxiosInstance.get(API_TRADING_ACCOUNTS_BASE, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      params: { id_tree: normalizedIdTree },
    });
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

export async function createBrokerTree(payload) {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    const res = await AxiosInstance.post(API_BROKER_TREES_BASE, payload, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    });

    return res;
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

export async function updateBrokerTree(payload, options = {}) {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    const res = await AxiosInstance.put(API_BROKER_TREES_BASE, payload, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    });

    return res;
  } catch (error) {
    console.error("error in request:", error);
    if (options.throwOnError) {
      throw error;
    }
    return null;
  }
}

export async function deleteBrokerTree(id) {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    const res = await AxiosInstance.delete(
      `${API_BROKER_TREES_BASE}?id=${encodeURIComponent(id)}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        },
      }
    );

    return res;
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

const BrokerTreesService = {
  getBrokerTrees,
  getTradingAccountsByTreeId,
  createBrokerTree,
  updateBrokerTree,
  deleteBrokerTree,
};

export default BrokerTreesService;
